// extracted by mini-css-extract-plugin
export default {"SectionTabs":"SectionTabs_SectionTabs__F1opU"};